
export const MAX_CHALLENGES = 1024;
export const MAX_PACKET_ENTITIES = 256; // Standard Q2 value
export const UPDATE_BACKUP = 16;
export const CMD_BACKUP = 64;
export const MAX_INFO_STRING = 512;
export const MAX_MSGLEN = 1400; // MTU safe limit

// Muzzle Flash Constants
export const MZ_BLASTER = 0;
export const MZ_MACHINEGUN = 1;
export const MZ_SHOTGUN = 2;
export const MZ_CHAINGUN1 = 3;
export const MZ_CHAINGUN2 = 4;
export const MZ_CHAINGUN3 = 5;
export const MZ_RAILGUN = 6;
export const MZ_ROCKET = 7;
export const MZ_GRENADE = 8;
export const MZ_LOGIN = 9;
export const MZ_LOGOUT = 10;
export const MZ_SSHOTGUN = 11;
export const MZ_BFG = 12;
export const MZ_HYPERBLASTER = 13;

// Xatrix / Rogue Extensions
export const MZ_IONRIPPER = 16;
export const MZ_BLUEHYPERBLASTER = 17;
export const MZ_PHALANX = 18;
export const MZ_BFG2 = 19;
export const MZ_PHALANX2 = 20;
export const MZ_ETF_RIFLE = 30;
export const MZ_PROX = 31;
export const MZ_ETF_RIFLE_2 = 32;
export const MZ_HEATBEAM = 33;
export const MZ_BLASTER2 = 34;
export const MZ_TRACKER = 35;
export const MZ_NUKE1 = 36;
export const MZ_NUKE2 = 37;
export const MZ_NUKE4 = 38;
export const MZ_NUKE8 = 39;
